export const PROJECT_QUERY_KEY = "project";
